export default {
  subtitle: "Statement/Report",
  path: "bank_account_statement",
  paragraph: "To get a statement of an internal account you can use the following endpoint. If wanted, you can also filter for date/time intervals.",
  request:  {
    method: "GET",
    endpoint: "/bank_accounts/:id/statement",
    responses: {
      "data": [
        {
          "wire_id": "9292fdf5-c0c1-467c-ba5c-dcc511450210",
          "value": "249.38",
          "subject_id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
          "social_name": "POWER HOME THEATER",
          "kind": "DEBIT",
          "inserted_at": "2022-05-11T20:49:31Z",
          "id": "b2d8eabe-4754-43e4-a7a9-93adeb8e679c",
          "exchanged_value": "1300.00",
          "exchange_rate": "5.21518",
          "exchange_id": "4be232cc-40e7-489d-b010-30df251b4464",
          "exchange_currency": "BRL",
          "document_type": "tax_id",
          "document_number": "2348909854385",
          "currency": "EUR"
        }
      ]
    }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Your internal bank account ID"
    }
  ],
  queryPayload: [
    {
      name: "from",
      type: "string",
      required: false,
      description: "Date/time beginning interval, e.g.: 2022-01-01T03%3A00%3A00.000Z"
    },
    {
      name: "to",
      type: "string",
      required: false,
      description: "Date/time end interval, e.g.: 2022-03-01T03%3A00%3A00.000Z"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/InternalBankAccountStatement.js